import {
	axiosApi
} from "./api.js";
// 登录接口
// export let loginInt = fromdata => {
// 	return axiosApi({
// 		url: "/outer/login/loginInt",
// 		method: "get",
// 		params: {
// 			params: fromdata
// 		}
// 	});
// };
// 专利添加
// export let AddPatentInterface = (fromdata) => {
// 	return axiosApi({
// 		url: "/api/patent",
// 		method: "post",
// 		data:fromdata
// 	});
// };

// 商家名录：/api/enterprise/list 这个接口
export let enterpriseList = fromdata => {
	return axiosApi({
		url: "/api/enterprise/list",
		method: "get",
		params: fromdata
	});
}
export let gitEnterpriseListObj = fromdata => {
	return axiosApi({
		url: "/api/enterprise",
		method: "get",
		params: fromdata
	});
}

// 通知公告 ： /api/information/list?type=1 这个接口
export let informationList = fromdata => {
	return axiosApi({
		url: "/api/information/list?type=1",
		method: "get",
		params: fromdata
	});
}
// 获取通知公告详情
export let gitinformationListObj = fromdata => {
	return axiosApi({
		url: "/api/information",
		method: "get",
		params: fromdata
	});
}

// 待转化 /api/achievement/list?status=0
// 已转化的列表/api/achievement/list?status=1
export let achievementList = fromdata => {
	return axiosApi({
		url: "/api/achievement/list",
		method: "get",
		params: fromdata
	});
}

export let gitAchievementObj = fromdata => {
	return axiosApi({
		url: "/api/achievement",
		method: "get",
		params: fromdata
	});
}


// 专利添加
export let AddAudit = (fromdata) => {
	return axiosApi({
		url: "/api/ip/update",
		method: "post",
		data:fromdata
	});
};







